module.exports = __webpack_public_path__ + "img/output-onlinegiftools (34).2669b2ff.gif";